import * as React from "react";
import type { SVGProps } from "react";
const SvgLogoDropbox = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 164 49"
    {...props}
  >
    <g clipPath="url(#Logo_Dropbox_svg__a)">
      <path
        fill="currentColor"
        d="M45.472 14.161h7.623c4.859 0 8.873 2.812 8.873 9.231v1.349c0 6.468-3.754 9.377-8.727 9.377h-7.769zm4.258 3.624v12.693h3.267c2.763 0 4.616-1.804 4.616-5.818v-1.057c0-4.014-1.95-5.818-4.762-5.818zm14.497.195h3.413l.553 3.754c.65-2.551 2.307-3.916 5.314-3.916h1.056v4.307h-1.755c-3.462 0-4.307 1.202-4.307 4.615v7.427h-4.209V17.98zM75.408 26.4v-.455c0-5.412 3.462-8.37 8.175-8.37 4.81 0 8.175 2.958 8.175 8.37v.455c0 5.314-3.267 8.174-8.175 8.174-5.217-.048-8.175-2.844-8.175-8.174m12.043-.049v-.406c0-3.007-1.511-4.81-3.917-4.81-2.356 0-3.916 1.657-3.916 4.81v.406c0 2.91 1.511 4.567 3.916 4.567 2.406-.049 3.917-1.658 3.917-4.567m6.517-8.37h3.51l.407 3.056c.845-2.048 2.649-3.462 5.314-3.462 4.112 0 6.826 2.958 6.826 8.435v.455c0 5.314-3.007 8.126-6.826 8.126-2.551 0-4.307-1.154-5.168-3.007v8.175H93.92zm11.783 8.37v-.358c0-3.217-1.658-4.81-3.868-4.81-2.357 0-3.917 1.804-3.917 4.81v.31c0 2.86 1.512 4.663 3.868 4.663 2.422-.048 3.917-1.592 3.917-4.615m10.498 4.827-.357 2.958h-3.608V12.568h4.112v8.273c.91-2.113 2.714-3.267 5.265-3.267 3.868.049 6.729 2.714 6.729 8.077v.504c0 5.363-2.714 8.435-6.826 8.435-2.714-.065-4.469-1.317-5.315-3.413m7.818-5.022v-.406c0-2.958-1.609-4.616-3.868-4.616-2.308 0-3.917 1.853-3.917 4.664v.358c0 3.007 1.56 4.762 3.868 4.762 2.47 0 3.917-1.544 3.917-4.762m6.127.244v-.455c0-5.412 3.461-8.37 8.174-8.37 4.811 0 8.175 2.958 8.175 8.37v.455c0 5.314-3.315 8.174-8.175 8.174-5.217-.048-8.174-2.844-8.174-8.174m12.075-.049v-.406c0-3.007-1.512-4.81-3.917-4.81-2.356 0-3.917 1.657-3.917 4.81v.406c0 2.91 1.512 4.567 3.917 4.567 2.422-.049 3.917-1.658 3.917-4.567m9.783-.601-5.671-7.769h4.859l3.266 4.86 3.316-4.86h4.81l-5.753 7.72 6.062 8.435h-4.762l-3.705-5.363-3.608 5.363h-4.973z"
      />
      <path
        fill="#0061FF"
        d="m19.274 14.16-9.426 6.014 9.426 6.013L9.848 32.2.422 26.155l9.426-6.014-9.426-5.98 9.426-6.014zM9.8 34.135l9.427-6.013 9.426 6.013-9.426 6.014zm9.475-7.98 9.426-6.013-9.426-5.98 9.378-6.014 9.426 6.014-9.426 6.013 9.426 6.013-9.426 6.013z"
      />
    </g>
    <defs>
      <clipPath id="Logo_Dropbox_svg__a">
        <path
          fill="#fff"
          d="M.422.147h163v48h-163z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoDropbox;
